/**
 * @generated SignedSource<<6deac11010d87cd9f65e8faef99646be>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoomRatesTableRateEditorForm_package$data = {
  readonly transferPrice: number | null;
  readonly " $fragmentType": "RoomRatesTableRateEditorForm_package";
};
export type RoomRatesTableRateEditorForm_package$key = {
  readonly " $data"?: RoomRatesTableRateEditorForm_package$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesTableRateEditorForm_package">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoomRatesTableRateEditorForm_package",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "transferPrice",
      "storageKey": null
    }
  ],
  "type": "Package",
  "abstractKey": null
};

(node as any).hash = "fa9fd54dab344baac95e891726949177";

export default node;
